export const stationScreenshot =
  'https://cdn.magicpatterns.com/uploads/9PgVysqJh8jC3Dw6oZmj8M/Screenshot_2026-10-22_at_11.03.14.png'

export const stationFeaturedImage =
  'https://cdn.magicpatterns.com/uploads/iWiV1M7B56mnSxRzVtqKDv/Screenshot_2026-10-22_at_08.39.27.png'

/** Pixel size of the Snakker Station screenshot the shelf thumbnails are cropped from. */
export const stationSource = { width: 2520, height: 1479 }

export const stationFilters = [
  'All',
  'Market research',
  'Rep support',
  'Banners / hooks',
  'Study update',
  'Congress',
  'Follow-up',
] as const

export type StationFilter = (typeof stationFilters)[number]

export interface ShelfSnak {
  id: string
  title: string
  category: Exclude<StationFilter, 'All'>
  x: number
  y: number
}

/** Thumbnail crops (313 × 321 px) from the Station screenshot. */
export const shelfSnaks: ShelfSnak[] = [
  { id: 'itch', title: 'Just an itch? — evidence challenge', category: 'Congress', x: 1075, y: 284 },
  { id: 'study', title: '87% — four-year study update', category: 'Study update', x: 1417, y: 284 },
  { id: 'pulse', title: 'Eye Care Pulse — peer poll', category: 'Congress', x: 1759, y: 284 },
  { id: 'booth', title: 'The analysis — booth iPad', category: 'Congress', x: 2101, y: 284 },
  { id: 'oct', title: '5 OCT variables — follow-up', category: 'Follow-up', x: 1075, y: 744 },
  { id: 'guide', title: 'Patient application guide', category: 'Rep support', x: 1417, y: 744 },
  { id: 'banner', title: 'Have you seen it yet? — banner', category: 'Banners / hooks', x: 1759, y: 744 },
]

export const shelfThumb = { width: 313, height: 321 }

export const featuredSnak = {
  category: 'Portfolio introduction',
  title: 'Meet the Filteks — family introduction',
  usedIn: 'Used in the Filtek website pilot',
  solves: 'Make the Filtek family easy to understand and remember',
  channels: ['Email', 'Web', 'Rep iPad'],
}

export const stationPillars = [
  { label: 'Control', text: 'Control Tower provides central visibility.' },
  { label: 'Empower', text: 'Station gives local markets access to existing Snaks and inspiration.' },
  {
    label: 'Optimize',
    text: 'Performance intelligence, pulse insights and recommendations help everyone improve.',
  },
]
